import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Typography } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
    container: {
        flex: 1,
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
    },
    sub: {
        opacity: 0.5,
    },
}));

const NotFoundAlert = (props) => {
    const classes = useStyles(props);

    return (
        <div className={classes.container}>
            <Typography variant="h3" className={classes.parent}>
                Alert not found
            </Typography>
            <Typography variant="body1" className={classes.sub}>
                Select one or add a new
            </Typography>
        </div>
    );
};

export default NotFoundAlert;
